/** 后台浏览器页面的基址。Umi 的 Link 和 history 会自动加前缀。 */
export const ADMIN_PAGE_BASE = '/admin/v1';
export const ADMIN_LOGIN_ROUTE = '/user/login';

/** 从浏览器地址提取 Umi 内部路径，供登录和菜单权限匹配使用。 */
export function adminRoutePath(pathname: string) {
  if (pathname === ADMIN_PAGE_BASE) return '/';
  return pathname.startsWith(ADMIN_PAGE_BASE + '/')
    ? pathname.slice(ADMIN_PAGE_BASE.length)
    : pathname;
}

/** 生成原生浏览器跳转地址，接受站内绝对路径，拒绝外部地址和登录页回跳。 */
export function adminPageUrl(path: string | null, afterLogin = false) {
  const home = ADMIN_PAGE_BASE + '/';
  if (!path?.startsWith('/') || path.startsWith('//') || path.includes('\\')) return home;
  const url = new URL(path, 'https://admin.invalid');
  const route = adminRoutePath(url.pathname);
  if (afterLogin && route.replace(/\/+$/, '') === ADMIN_LOGIN_ROUTE) return home;
  return ADMIN_PAGE_BASE + route + url.search + url.hash;
}
